import { render, staticRenderFns } from "./EmptyRouterView.vue?vue&type=template&id=5455d1e0&"
import script from "./EmptyRouterView.vue?vue&type=script&lang=ts&"
export * from "./EmptyRouterView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports